import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  TablePagination,
  CircularProgress,
} from '@material-ui/core';

const styles = {
  inheritFontWeight: {
    fontWeight: 'inherit',
  },
}

class BrokerDealerStates extends Component {
  _isMounted = false;

  state = {
    brokerDealerStates: [],
    currentPage: 0,
    totalItems: 0,
    nextPage: 0,
    status: 'fetching',
    message: null,
  }

  componentDidMount() {
    this._isMounted = true;

    this.props.handleFetchBrokerDealerStates(this.props.adminUserSession, this.props.riaContactId)
      .then(() => {
        if (this._isMounted && this.props.brokerDealerStates !== undefined) {
          const { status, message, broker_dealer_states, pagy } = this.props.brokerDealerStates;

          this.setState({
            brokerDealerStates: broker_dealer_states,
            currentPage: pagy.page - 1,
            totalItems: pagy.count,
            nextPage: pagy.next,
            status,
            message,
          })
        }
      })
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleFetchBrokerDealerStates = () => {
    this.props.handleFetchBrokerDealerStates(this.props.adminUserSession, this.props.riaContactId, { page: this.state.nextPage })
      .then(() => {
        if (this._isMounted && this.props.brokerDealerStates !== undefined) {
          const { status, message, broker_dealer_states, pagy } = this.props.brokerDealerStates;

          this.setState({
            brokerDealerStates: broker_dealer_states,
            currentPage: pagy.page - 1,
            totalItems: pagy.count,
            nextPage: pagy.next,
            status,
            message,
          })
        }
      })
  }

  renderBrokerDealerState = (brokerDealerState, index) => {
    return (
      <TableRow hover key={`broker-dealer-state-${index}`}>
        <TableCell>
          {brokerDealerState.registration_scope}
        </TableCell>
        <TableCell>
          {brokerDealerState.state}
        </TableCell>
        <TableCell>
          {brokerDealerState.registration_date}
        </TableCell>
      </TableRow>
    )
  }

  render() {
    const { classes } = this.props;
    const {
      brokerDealerStates,
      totalItems,
      currentPage,
      status,
      message,
    } = this.state;



    return(
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.inheritFontWeight}>Scope</TableCell>
              <TableCell className={classes.inheritFontWeight}>State</TableCell>
              <TableCell className={classes.inheritFontWeight}>Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              status === 'error' ? <TableRow><TableCell>{message}</TableCell></TableRow>
              :
              (status === 'fetched' ? brokerDealerStates.map((brokerDealerState, index) => this.renderBrokerDealerState(brokerDealerState, index)) : <TableRow><TableCell><CircularProgress /></TableCell></TableRow>)
            }
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={totalItems}
          onChangePage={this.handleFetchBrokerDealerStates}
          page={currentPage}
          rowsPerPage={10}
          rowsPerPageOptions={[]}
        />
      </TableContainer>
    )
  }

}

BrokerDealerStates.propTypes = {
  riaContactId: PropTypes.number.isRequired
}

export default withStyles(styles)(BrokerDealerStates);